"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceSample = void 0;
const core = __importStar(require("../../core"));
const SpeakerSeparationResponseModel_1 = require("./SpeakerSeparationResponseModel");
exports.VoiceSample = core.serialization.object({
    sampleId: core.serialization.property("sample_id", core.serialization.string().optional()),
    fileName: core.serialization.property("file_name", core.serialization.string().optional()),
    mimeType: core.serialization.property("mime_type", core.serialization.string().optional()),
    sizeBytes: core.serialization.property("size_bytes", core.serialization.number().optional()),
    hash: core.serialization.string().optional(),
    durationSecs: core.serialization.property("duration_secs", core.serialization.number().optional()),
    removeBackgroundNoise: core.serialization.property("remove_background_noise", core.serialization.boolean().optional()),
    hasIsolatedAudio: core.serialization.property("has_isolated_audio", core.serialization.boolean().optional()),
    hasIsolatedAudioPreview: core.serialization.property("has_isolated_audio_preview", core.serialization.boolean().optional()),
    speakerSeparation: core.serialization.property("speaker_separation", SpeakerSeparationResponseModel_1.SpeakerSeparationResponseModel.optional()),
    trimStart: core.serialization.property("trim_start", core.serialization.number().optional()),
    trimEnd: core.serialization.property("trim_end", core.serialization.number().optional()),
});
